import { render, staticRenderFns } from "./TalentTestimonials.vue?vue&type=template&id=1e4082c2&"
import script from "./TalentTestimonials.vue?vue&type=script&lang=js&"
export * from "./TalentTestimonials.vue?vue&type=script&lang=js&"
import style0 from "./TalentTestimonials.vue?vue&type=style&index=0&id=1e4082c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports